<template>
  <div />
</template>

<script>
import { mapGetters } from 'vuex'
import { getEventList } from '@/api/commons'
export default {
  name: 'Event',
  data() {
    return {
      timer: null,
      pause: false,
      counter: 0
    }
  },
  computed: {
    ...mapGetters(['goodsVer'])
  },
  mounted() {
    this.start()
  },
  beforeDestroy() {
    this.pause = true
    this.counter = 0
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    query() {
      getEventList({
        type: this.CONST.EVENT_TYPES.find(type => type.name === '产品').id
      }).then(resp => {
        const rows = resp.rows || []
        if (rows.length > 0) {
          if (this.goodsVer !== rows[0].ver) { // 版本发生变更后，需要更新缓存中的产品
            this.$store.dispatch('goods/init')
            this.$store.dispatch('goods/setGoodsVer', rows[0].ver)
          }
        }
        this.restart()
      }).catch(_ => {
        this.restart()
      })
    },
    start() {
      this.timer = setInterval(() => { // 创建特殊事件定时器
        if (!this.pause) {
          if (++this.counter === this.CONST.EVENT_INTERVAL) {
            this.query()
          }
        }
      }, 1000)
    },
    stop() {
      this.pause = true
      this.counter = 0
    },
    restart() {
      this.pause = false
      this.counter = 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/event.vue